import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './runtime.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getQuotingId = createSelector(selectProjectState, (state: State) => state.quotingId);
